interface ToastProps {
  state: any;
  setToast: (ref: any) => void;
  onShow: (
    message: string,
    status: "danger" | "success" | "info",
    position: "right" | "center" | "left"
  ) => void;
}

export const Toast: ToastProps = {
  state: {
    toast: {},
  },
  setToast: (ref: any) => (Toast.state.toast = ref),
  onShow: (message, status, position) => {
    Toast.state.toast.onShow(message, status, position);
  },
};
